function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  function t(n) {
    if (i[n]) return i[n].exports;
    var a = i[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(a.exports, a, a.exports, t), a.l = !0, a.exports;
  }

  var i = {};
  return t.m = e, t.c = i, t.d = function (e, i, n) {
    t.o(e, i) || Object.defineProperty(e, i, {
      configurable: !1,
      enumerable: !0,
      get: n
    });
  }, t.n = function (e) {
    var i = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(i, "a", i), i;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t(t.s = 0);
}([function (e, t, i) {
  e.exports = i(1);
}, function (e, t, i) {
  "use strict";

  function n(e) {
    return (n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    })(e);
  }

  function a(e) {
    return v()(e) ? e : [e];
  }

  function r(e) {
    return "[object Date]" === Object.prototype.toString.call(e);
  }

  function o(e) {
    if (null === e || "object" !== n(e) || r(e)) return e;
    if (v()(e)) return e.map(o);
    var t = {};
    return k()(e).forEach(function (i) {
      t[y()(i)] = o(e[i]);
    }), t;
  }

  function l(e, t) {
    var i = t.camelizeKeys,
        n = t.camelizeTypeValues,
        a = {};
    return k()(e).forEach(function (t) {
      var r = e[t],
          l = i ? y()(t) : t;
      a[l] = {}, void 0 !== r.data && (v()(r.data) ? a[l].data = r.data.map(function (e) {
        return {
          id: e.id,
          type: n ? y()(e.type) : e.type
        };
      }) : b()(r.data) ? a[l].data = r.data : a[l].data = {
        id: r.data.id,
        type: n ? y()(r.data.type) : r.data.type
      }, void 0 !== r.meta && (a[l].meta = o(r.meta))), r.links && (a[l].links = i ? o(r.links) : r.links);
    }), a;
  }

  function u(e, t) {
    if (t.camelizeKeys) {
      var i = {};
      return k()(e).forEach(function (t) {
        i[y()(t)] = o(e[t]);
      }), i;
    }

    return e;
  }

  function s(e, t) {
    var i = t.camelizeKeys,
        n = t.camelizeTypeValues,
        r = {};
    return a(e).forEach(function (e) {
      var t = i ? y()(e.type) : e.type;
      r[t] = r[t] || {}, r[t][e.id] = r[t][e.id] || {
        id: e.id
      }, r[t][e.id].type = n ? y()(e.type) : e.type, i ? (r[t][e.id].attributes = {}, k()(e.attributes).forEach(function (i) {
        r[t][e.id].attributes[y()(i)] = o(e.attributes[i]);
      })) : r[t][e.id].attributes = e.attributes, e.links && (r[t][e.id].links = {}, k()(e.links).forEach(function (n) {
        var a = i ? y()(n) : n;
        r[t][e.id].links[a] = e.links[n];
      })), e.relationships && (r[t][e.id].relationships = l(e.relationships, {
        camelizeKeys: i,
        camelizeTypeValues: n
      })), e.meta && (r[t][e.id].meta = u(e.meta, {
        camelizeKeys: i
      }));
    }), r;
  }

  function c(e) {
    return e.replace(/\?.*$/, "");
  }

  function p(e, t, i) {
    var n = i.camelizeKeys,
        r = i.camelizeTypeValues,
        o = i.filterEndpoint,
        s = {};
    s.meta = {};
    var p;
    if (o) s.meta[t] = {}, p = s.meta[t];else {
      var d = c(t);
      s.meta[d] = {}, s.meta[d][t.slice(d.length)] = {}, p = s.meta[d][t.slice(d.length)];
    }

    if (p.data = {}, e.data) {
      var f = [];
      a(e.data).forEach(function (e) {
        var t = {
          id: e.id,
          type: r ? y()(e.type) : e.type
        };
        e.relationships && (t.relationships = l(e.relationships, {
          camelizeKeys: n,
          camelizeTypeValues: r
        })), f.push(t);
      }), p.data = f;
    }

    return e.links && (p.links = e.links, s.meta[c(t)].links = e.links), e.meta && (p.meta = u(e.meta, {
      camelizeKeys: n
    })), s;
  }

  function d(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        i = {},
        n = t.endpoint,
        a = t.filterEndpoint,
        r = t.camelizeKeys,
        o = t.camelizeTypeValues;

    if (void 0 === a && (a = !0), void 0 === r && (r = !0), void 0 === o && (o = !0), e.data && K()(i, s(e.data, {
      camelizeKeys: r,
      camelizeTypeValues: o
    })), e.included && K()(i, s(e.included, {
      camelizeKeys: r,
      camelizeTypeValues: o
    })), n) {
      var l = a ? c(n) : n;
      K()(i, p(e, l, {
        camelizeKeys: r,
        camelizeTypeValues: o,
        filterEndpoint: a
      }));
    }

    return i;
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  var f = i(2),
      y = i.n(f),
      m = i(3),
      v = i.n(m),
      h = i(4),
      b = i.n(h),
      z = i(5),
      k = i.n(z),
      x = i(6),
      K = i.n(x);
}, function (e, t) {
  e.exports = require("lodash/camelCase");
}, function (e, t) {
  e.exports = require("lodash/isArray");
}, function (e, t) {
  e.exports = require("lodash/isNull");
}, function (e, t) {
  e.exports = require("lodash/keys");
}, function (e, t) {
  e.exports = require("lodash/merge");
}]);